import { useState } from "react";
import type { Player } from "../types";

interface PlayerManagerProps {
	players: Player[];
	onAddPlayer: (name: string) => void;
	onRemovePlayer: (id: string) => void;
}

export function PlayerManager({
	players,
	onAddPlayer,
	onRemovePlayer,
}: PlayerManagerProps) {
	const [name, setName] = useState("");
	const [bulkMode, setBulkMode] = useState(false);
	const [bulkNames, setBulkNames] = useState("");

	const handleSubmit = (e: React.FormEvent) => {
		e.preventDefault();
		if (bulkMode) {
			const names = bulkNames
				.split("\n")
				.map((n) => n.trim())
				.filter((n) => n);
			names.forEach(onAddPlayer);
			setBulkNames("");
		} else {
			onAddPlayer(name);
			setName("");
		}
	};

	return (
		<div className="card player-manager">
			<h2>Players</h2>
			<form onSubmit={handleSubmit}>
				<div className="mode-toggle">
					<button
						type="button"
						className={!bulkMode ? "active" : ""}
						onClick={() => setBulkMode(false)}
					>
						Single
					</button>
					<button
						type="button"
						className={bulkMode ? "active" : ""}
						onClick={() => setBulkMode(true)}
					>
						Bulk
					</button>
				</div>
				{bulkMode ? (
					<textarea
						value={bulkNames}
						onChange={(e) => setBulkNames(e.target.value)}
						placeholder="Enter names (one per line)"
						rows={4}
					/>
				) : (
					<input
						type="text"
						value={name}
						onChange={(e) => setName(e.target.value)}
						placeholder="Enter player name"
					/>
				)}
				<button type="submit" className="btn-primary">
					Add Player{bulkMode ? "s" : ""}
				</button>
			</form>
			{players.length > 0 && (
				<div className="player-list">
					<h3>Current Players ({players.length})</h3>
					<ul>
						{players.map((player) => (
							<li key={player.id}>
								<span>{player.name}</span>
								<button
									type="button"
									onClick={() => {
										if (window.confirm(`Remove ${player.name}?`)) {
											onRemovePlayer(player.id);
										}
									}}
									className="btn-remove"
									aria-label={`Remove ${player.name}`}
								>
									×
								</button>
							</li>
						))}
					</ul>
				</div>
			)}
		</div>
	);
}
